import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

export const royaltyPlanFeeTemplateStart = (accessToken, data) => baseAction.actionStart(actionTypes.ROYALTYPLANFEETEMPLATE_START, accessToken, data);
export const royaltyPlanFeeTemplateSuccess = (data) => baseAction.actionSuccess(actionTypes.ROYALTYPLANFEETEMPLATE_SUCCESS, data);
export const royaltyPlanFeeTemplateFail = (error) => baseAction.actionFail(actionTypes.ROYALTYPLANFEETEMPLATE_FAIL, error);

export const royaltyPlanFeeTemplateSelect = (options) => {
  return (dispatch, getState) => {
    if (options && options.royaltyPlanFeeTemplateId) {
      baseAction.actionExecute(dispatch, getState, {
        url: `/RoyaltyPlanFeeTemplate/${options.feeType}/${options.royaltyPlanFeeTemplateId}`,
        startFn: (accessToken) => dispatch(royaltyPlanFeeTemplateStart(accessToken, { lastScope: 'select' })),
        successFn: (response) => dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplate: response.data, isNew: false })),
        failFn: (error) => dispatch(royaltyPlanFeeTemplateFail(error))
      });
    } else {
      dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplate: null, isNew: true }));
    }
  };
};

export const royaltyPlanFeeTemplateList = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      url: `/RoyaltyPlanFeeTemplate/RoyaltyPlan/${options.royaltyPlanTemplateId}/${options.feeType}`,
      startFn: (accessToken) => dispatch(royaltyPlanFeeTemplateStart(accessToken, { lastScope: 'list' })),
      successFn: (response) => dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplates: response.data })),
      failFn: (error) => dispatch(royaltyPlanFeeTemplateFail(error))
    });
  };
};

export const royaltyPlanFeeTemplateListReset = (options) => {
  return {
    type: actionTypes.ROYALTYPLANFEETEMPLATE_LISTRESET,
    data: {
      royaltyPlanFeeTemplates: null,
    }
  };
};

export const royaltyPlanFeeTemplateCreate = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'create',
      url: `/RoyaltyPlanFeeTemplate/RoyaltyPlan/${options.royaltyPlanTemplateId}/${options.feeType}`,
      payload: options.data,
      startFn: (accessToken) => dispatch(royaltyPlanFeeTemplateStart(accessToken, { lastScope: 'create' })),
      successFn: (response) => dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplate: response.data, isNew: false })),
      failFn: (error) => dispatch(royaltyPlanFeeTemplateFail(error))
    });
  };
};

export const royaltyPlanFeeTemplateUpdate = (options) => {  
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'update',
      url: `/RoyaltyPlanFeeTemplate/${options.feeType}/${options.royaltyPlanFeeTemplateId}`,
      payload: options.data,
      startFn: (accessToken) => dispatch(royaltyPlanFeeTemplateStart(accessToken, { lastScope: 'update' })),
      successFn: (response) => dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplate: response.data, isNew: false })),
      failFn: (error) => dispatch(royaltyPlanFeeTemplateFail(error))
    });
  };
};

export const royaltyPlanFeeTemplateDelete = (options) => {
  return (dispatch, getState) => {
    baseAction.actionExecute(dispatch, getState, {
      type: 'delete',
      url: `/RoyaltyPlanFeeTemplate/${options.feeType}/${options.royaltyPlanFeeTemplateId}`,
      startFn: (accessToken) => dispatch(royaltyPlanFeeTemplateStart(accessToken, { lastScope: 'delete' })),
      successFn: () => dispatch(royaltyPlanFeeTemplateSuccess({ royaltyPlanFeeTemplate: null, isNew: false })),
      failFn: (error) => dispatch(royaltyPlanFeeTemplateFail(error))      
    });
  };
};
